import React, { Component } from 'react';
import * as types from '../../../constants/actionTypes';
import PropTypes from 'prop-types';
import Drawer from '../../Common/Drawer/Drawer';
import Notification from '../../Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import { TruncateText } from '../../../helpers/strings';
import FileTypeIcon from '../../Common/FileTypeIcon';
import './ProjectsWidgetDrawer.scss';

export class ProjectsWidgetDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isLoading: true,
            locations: []
        }
    }

    componentDidMount = async () => {
        await this.loadLocations();
    }

    componentDidUpdate = async (prevProps) => {
        if (this.props.project && (
            (this.props.project.id != prevProps.project.id) ||
            (this.props.project.sliceName != prevProps.project.sliceName) ||
            (this.props.project.barTitle != prevProps.project.barTitle)
        )) {
            await this.loadLocations();
        }
    }

    loadLocations = async () => {
        this.setState({ isLoading: true });
        try {
            const response = await this.props.compDashboardActions.loadLocations(this.props.project.id, this.props.project.sliceName, this.props.project.barTitle, this.props.filters);
            if (response.type === types.LOAD_COMPANY_DASHBOARD_LOCATIONS_SUCCESS) {
                this.setState({ locations: response.payload.locationTotals });
            } else if (response.type === types.LOAD_COMPANY_DASHBOARD_LOCATIONS_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    excelExport = async () => {
        try {
            await this.props.compDashboardActions.exportLocations(this.props.project.id, this.props.project.sliceName, this.props.project.barTitle, this.props.filters);
        } catch (error) {
            Notification("error", "Error", error);
        }
    }

    render() {

        const title = TruncateText(this.props.project.name, 30) + " Locations";

        return (
            <Drawer isWide={false}
                onCancelClick={this.props.onComplete}
                saveText='Close'
                title={title}>
                <LoadingIndicator isLoading={this.state.isLoading}>
                    <div className="projects-widget-drawer">
                        <div className="row">
                            <div className="col pb-2" onClick={this.excelExport}>
                                <div className="icon float-end">
                                    <FileTypeIcon extension=".xlsx" /> Export
                                </div>
                            </div>
                        </div>
                        <div className="row m-1">
                            { this.state.locations && this.state.locations.length > 0 ?
                                <ul className="list-group list-group-flush w-100">
                                    {this.state.locations.map(loc => {
                                        return (
                                            <li className="list-group-item d-flex justify-content-between align-items-center" key={loc.locationId}>
                                                {loc.locationName}
                                                <span className="badge badge-primary badge-pill">{loc.totalTasks}</span>
                                            </li>
                                        )
                                    })
                                    }
                                </ul>
                                : <p>No locations found.</p>
                            }
                        </div>
                    </div>
                </LoadingIndicator>
            </Drawer>
        )
    }
}

ProjectsWidgetDrawer.propTypes = {
    project: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired,
    compDashboardActions: PropTypes.object.isRequired
};

export default ProjectsWidgetDrawer;